import { type RangeBoundaries } from 'instantsearch.js/es/connectors/range/connectRange'
import { type JSX } from 'react'

const PRODUCT_SEARCH_REFINEMENT_RANGE_COUNT = 1

export const productSearchRefinementRangeRenderValue = (
  formLabel: string,
  start: RangeBoundaries,
): JSX.Element => (
  <>
    <span className="truncate">{formLabel}</span>
    {start.some((item) => Number.isFinite(item)) && (
      <span className="text-dark-primary-strong">
        {PRODUCT_SEARCH_REFINEMENT_RANGE_COUNT}
      </span>
    )}
  </>
)
